import React from 'react';
import PropTypes from 'prop-types';

export function RenderNode(type, Component) {
  return {
    renderNode(props, editor, next) {
      if (type === props.node.type) {
        return <Component {...props} />;
      }
      return next();
    },
  };
}

RenderNode.propTypes = {
  type: PropTypes.string,
  Component: PropTypes.node,
};
